
<b-sidebar
  ref="chat"
  title="Distanstolkning"
  v-model="show"
  right
  z-index="800"
  :header-class="{ navOpen: nav }"
  no-close-on-esc
>
  <!-- <div style="height:15%">
    <div class="sidebar-field">
      <b-icon icon="person-fill" />
      <span class="float-right">
        Anslutna
      </span>
    </div>
    <div v-for="(interpreter, idx) in interpreters">
      <b-badge>{{ interpreter }}</b-badge>
    </div>
    <div v-for="(user, idx) in users">
      <b-badge></b-badge>
    </div>
  </div>
 -->
  <div
    :class="{ chatFocused: focused, textFocused: !focused }"
    style="height: 100%; overflow-y: hidden"
    @click="onFocus"
  >
    <div class="sidebar-field">
      <b-icon icon="chat-dots-fill" />
      <span class="float-right"> Chatt &mdash; {{ time }} </span>
    </div>
    <div style="height: 93%; overflow-y: scroll">
      <b-list-group v-for="(msg, i) in messages" :key="msg.id + '_' + i">
        <b-list-group-item
          style="white-space: pre-wrap"
          :class="{ bgOther: !msg.me }"
        >
          <small
            ><i>[{{ msg.timestamp }}]</i> &ndash; {{ msg.name }}:</small
          ><span v-if="msg.message == 'killercat'"
            ><img src="../../assets/killercat.gif" /></span
          ><span v-else
            ><b>{{ msg.message }}</b></span
          >
        </b-list-group-item>
      </b-list-group>
      <b-list-group-item
        ref="lastMessage"
        style="background-color: #ddd"
      ></b-list-group-item>
    </div>
  </div>
  <template #footer="{}">
    <b-form @click="onFocus" @submit.prevent="send" autocomplete="off">
      <div class="px-3 py-2">
        <b-row class="d-flex align-items-center">
          <b-col cols="9">
            <b-dropdown
              :text="targets[form.index].text"
              dropup
              block
              :variant="targets[form.index].variant"
              class="m-2"
            >
              <b-dropdown-item
                v-for="(target, i) in targets"
                :key="target.value"
                :value="target.value"
                :active="form.index == i"
                @click="selectTarget(i)"
              >
                {{ target.text }}
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col cols="1">
            <kbd>TAB</kbd>
          </b-col>
        </b-row>
      </div>
      <!--          <b-form-select v-model="form.to" :options="targets"  style="background-color: red"></b-form-select>-->
      <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <b-form-input
          ref="input"
          v-model="form.message"
          autofocus
          placeholder="Skriv ett meddelande..."
          @focus="focused = true"
          @blur="focused = false"
          @keydown.esc.prevent="hideNav"
          @keydown.tab.prevent="changeTarget"
        ></b-form-input>
        <b-button type="submit" size="sm">Skicka</b-button>
      </div>
    </b-form>
  </template>
</b-sidebar>
